"use client";

import { StepLoaderBody } from "@/components/loading";
import { StepViewProps } from "@/core/flow/types";
import { useFlowTaskPolling } from "./use-flow-task-polling";

export default function WaitingView({ flowId }: StepViewProps) {
	const phase = useFlowTaskPolling({ flowId });
	return <StepLoaderBody as="h2" phase={phase} />;
}
